import type React from 'react'

const FileSitemapXml: React.FC = () => {
  return (
    <svg
      width="80"
      height="80"
      viewBox="0 0 80 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.7 55.599V20.399C20.7 18.5508 20.7013 17.2669 20.7829 16.2683C20.8629 15.2895 21.0114 14.7355 21.2232 14.3199C21.6834 13.4167 22.4177 12.6824 23.3208 12.2222C23.7365 12.0104 24.2905 11.8619 25.2692 11.7819C26.2679 11.7003 27.5518 11.699 29.4 11.699H43.6922C45.3629 11.699 45.9212 11.7099 46.4282 11.8316C46.9179 11.9492 47.3861 12.1432 47.8156 12.4064L48.7039 10.9569L47.8156 12.4064C48.2601 12.6787 48.6626 13.0658 49.844 14.2472L56.7518 21.155C57.9332 22.3364 58.3203 22.7389 58.5927 23.1834L60.0422 22.2952L58.5927 23.1834C58.8559 23.6129 59.0498 24.0811 59.1674 24.5709C59.2891 25.0778 59.3 25.6361 59.3 27.3068V55.599C59.3 57.4472 59.2987 58.7312 59.2171 59.7298C59.1371 60.7085 58.9886 61.2626 58.7768 61.6782C58.3166 62.5814 57.5823 63.3157 56.6792 63.7759C56.2635 63.9876 55.7095 64.1361 54.7308 64.2161C53.7321 64.2977 52.4482 64.299 50.6 64.299H29.4C27.5518 64.299 26.2679 64.2977 25.2692 64.2161C24.2905 64.1361 23.7365 63.9876 23.3208 63.7759C22.4177 63.3157 21.6834 62.5814 21.2232 61.6782C21.0114 61.2626 20.8629 60.7085 20.7829 59.7298C20.7013 58.7312 20.7 57.4472 20.7 55.599Z"
        stroke="#18C4A9"
        strokeWidth="3.4"
      />
      <path
        d="M52 28.699H53.7V25.299H52V28.699ZM47 28.699H52V25.299H47V28.699ZM42.3 12.999V23.999H45.7V12.999H42.3ZM47 25.299C46.282 25.299 45.7 24.717 45.7 23.999H42.3C42.3 26.5948 44.4043 28.699 47 28.699V25.299Z"
        fill="#18C4A9"
      />
      <rect x="15" y="37.999" width="50" height="32" fill="white" />
      <path
        d="M25 44.5C20.9529 48.5471 20.3561 49.1439 16.7084 52.7916C16.3179 53.1821 16.3166 53.8166 16.7071 54.2071L25 62.5"
        stroke="#18C4A9"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
      <path
        d="M45 42.5L35 64.5"
        stroke="#18C4A9"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
      <path
        d="M55 44.5C59.0471 48.5471 59.6439 49.1439 63.2916 52.7916C63.6821 53.1821 63.6834 53.8166 63.2929 54.2071L55 62.5"
        stroke="#18C4A9"
        strokeWidth="3.6"
        strokeLinecap="round"
      />
    </svg>
  )
}

export default FileSitemapXml
